<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">仓库</div>
                    <el-select
                        v-model="searchData.SId"
                        :loading="loading"
                        class="search-item"
                        size="small"
                        filterable
                        clearable
                        remote
                        @visible-change="warehouseVisibleChange($event)"
                    >
                        <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            >
                            <span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                        </el-option>
                    </el-select>
                    <div class="search-name">汽配分类</div>
                    <el-select
                            size="small"
                            class="search-item"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                </div>
                <div class="search-ctn-right" v-if="summaryStr">
                <div class="section-summary">
                    <div>
                        <span>{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'SaleTotalAmount', order: 'descending' }"
                    @sort-change="sortChange"
                    show-summary :summary-method="getSummaries"
                >
                    <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip width="180px" prop="Cate" label="汽配分类"></el-table-column>
                    <el-table-column show-overflow-tooltip width="140px" sortable prop="SaleTotalt" label="销售金额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="140px" sortable prop="SaleGoodsTotalt" label="销售商品总数"></el-table-column>
                    <el-table-column show-overflow-tooltip width="140px" sortable prop="SaleReturnTotalt" label="退货金额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="140px" sortable prop="SaleReturnGoodsTotalt" label="退货商品总数"></el-table-column>
                    <el-table-column show-overflow-tooltip width="140px" sortable prop="Totalt" label="实际销售额"></el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.Page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        <el-dialog
            :close-on-click-modal="false"
            title="更多查询条件"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-page-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="75px">
                    <el-form-item label="仓库">
                        <el-select
                        v-model="searchData.SId"
                        style="width: 100%"
                        size="small"
                        filterable
                        clearable
                        remote
                        @visible-change="warehouseVisibleChange($event)"
                    >
                        <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            >
                            <span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                        </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker class="search-item" style="width: 100%" v-model="dateTimes" size="small" :picker-options="pickerOptions" @change="onDateTimeSelect" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交时间">
                        <el-date-picker class="search-item" style="width: 100%" v-model="dateTimes2" size="small" :picker-options="pickerOptions" @change="onDateTimeSelect2" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'inventoryStat',
    components: {
        breadcrumb
    },
    data() {
        return {
            dateTimes: [],
            dateTimes2: [],
            loading: false,
            detailsVisible: false,
            searchData: {
                CStartDate: '',
                CEndDate: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                APCate:[],
                Page: 1,
                limit: 15
            },
            dialogVisible: false,
            tableData: [],
            tableDataLength: 0,
            warehouseList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            typeList:[]
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        let that = this;
        document.addEventListener('keydown', that.handleKeyEvent);
     
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        that.dateTimes2.push(date1);

        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        that.dateTimes2.unshift(date2);

        that.searchData.CStartDate = date2;
        that.searchData.CEndDate = date1;
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                e.preventDefault();
                that.dialogVisible = true;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogVisible) that.dialogVisible = false;
            }
            if (key === 13) {
                e.preventDefault();
                that.handleSearch();
                return;
            }
            //左键
            if (key == 37) {
                e.preventDefault();
                if (this.searchData.Page > 1) {
                    this.searchData.Page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                e.preventDefault();
                if (this.searchData.Page < Math.ceil(this.tableDataLength / this.searchData.limit)) {
                    this.searchData.Page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                SId: '',
                APCate:[],
                Page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes = [];
            this.dateTimes2 = [];
            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date1 = new Date(year1, month1, day1, 0);
            this.dateTimes2.push(date1);

            //前一天设定的日期时间
            let year2, month2, day2;
            d.setTime(d.getTime());
            [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date2 = new Date(year2, month2, day2, 0);
            this.dateTimes2.unshift(date2);

            this.searchData.CStartDate = date2;
            this.searchData.CEndDate = date1;

        },
        // 获取数据
        getTableData() {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/DataStatistics/AutoPartCateStatData',
                    data: that.searchData
                })
                .then(res => {
                    if (res.errcode != 201) {
                        that.tableData = res.data;
                        that.tableDataLength = res.count;
                    }
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                } else if (index == 1) {
                    sums[index] = '';
                } else {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] = sums[index].toFixed(2);
                    }
                }
            });

            return sums;
        },
        sortChange(event) {
            this.searchData.Page = 1;
            this.getTableData();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.Page - 1) * this.searchData.limit;
        },
        getWarehouse() {
            this.$util.getWarehouseNotAuth(1).then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        //选中时间
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = "";
                this.searchData.EndDate = "";
            }
        },
        onDateTimeSelect2(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = "";
                this.searchData.CEndDate = "";
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        searchGoodsType() {
            this.$util
                .searchGoodsType()
                .then(data => {
                    if (!data) return;
                    this.typeList = data;
                })
                .catch(() => {});
        },
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }

        .el-button {
            padding: 0;
        }
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 22px;
        height: 22px;
        margin-right: 10px;
    }
    .image-cus {
        width: 22px;
        height: 22px;
    }
}
</style>
